module.exports = __webpack_public_path__ + "img/Christmas-coupon-2.4e68de9.png";